import { useEffect, useRef } from 'react';
import { mountHeroRibbon } from './heroRibbonEngine';

interface HeroRibbonProps {
  /** Flip horizontally: ribbon runs top-left → bottom-right */
  mirror?: boolean;
  /** White-tinted lines for use on the blue CTA field */
  tone?: 'default' | 'onBlue';
}

/* Background-only layer: fills its parent, never intercepts clicks.
   Pointer motion is read from the parent so text above it still feeds the wake. */
export default function HeroRibbon({ mirror = false, tone = 'default' }: HeroRibbonProps) {
  const stageRef = useRef<HTMLDivElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const stage = stageRef.current;
    const canvas = canvasRef.current;
    if (!stage || !canvas) return undefined;
    return mountHeroRibbon(stage, canvas, stage.parentElement ?? stage, { mirror, tone });
  }, [mirror, tone]);

  return (
    <div ref={stageRef} className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <canvas ref={canvasRef} className="absolute inset-0 h-full w-full max-[520px]:opacity-65" />
    </div>
  );
}